import OutdareGo from "./OutdareGo";
import * as serviceWorker from './serviceWorker';
import WebApp from 'outdarego-api-v3';

require ('./style/flickity.scss');
require ('./style/style.scss');
require ('./style/header.scss');
require ('./style/store.scss');
require ('./style/login.scss');
require ('./style/checkout.scss');

window.WebApp = WebApp;
window.OutdareGo = OutdareGo;

WebApp.init();
WebApp.getNetwork().setIp(window.location.protocol+"//"+window.location.hostname);
WebApp.initCart();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();